import { type FC, type ReactNode } from 'react';

import styles from './SbSharedWordpressArticlesContainer.scss';

export const SbSharedWordpressArticlesContainer: FC<{ children: ReactNode }> = ({ children }) => {
    return <div className={styles.container}>{children}</div>;
};
